
    <div class="container" >
        <h1><strong>Blogs</strong></h1>
        <span class="bar-title mb-5"></span>
        <div class="row">
            <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">
                    <div  class="card-header d-flex flex-column " style="height: 300px;width: 100%; "  >    
                        <div id="hr-tool-img" class="img-wrap" style="height: 300px;width: 100%;  " 
                        [ngStyle]="{backgroundImage:'url(assets/images/netcore.png)'}" >
                        </div>
                    </div>
                    <div class="card card-body d-flex">
                            <h1 class="card-title"><b>Upload file to a folder in ASP.NET Core MVC</b></h1>
    
                            <p class="card-text">The purpose of this article is to show an easy way to use, 
                                when needed to upload files in projects. Here I’ll upload the files to a folder and
                                 then get the files to anywhere needed from that folder. I’ll be demonstrating the
                                  working of this using postman</p>
                            <div class="d-flex flex-row justify-content-center mt-auto">
                                <a href="https://mifmilan.medium.com/upload-file-to-a-folder-in-asp-net-core-mvc-2d6d34357f46" target="_blank" target="_blank" type="button" class="btn btn-primary mr-3">Read More</a>     
                            </div>       
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">
                    <div  class="card-header d-flex flex-column " style="height: 300px;width: 100%; "  >    
                        <div id="hr-tool-img" class="img-wrap" 
                        [ngStyle]="{backgroundImage:'url(assets/images/angular.png)'}" >
                        </div>
                    </div>
                    <div class="card card-body d-flex">
                            <h1 class="card-title"><b>Bindings in Angular</b></h1>
    
                            <p class="card-text">This article is about types of data bindings in Angular in 
                                brief with syntax and example, which will be an asset to beginners of Angular. In this article I have shown the 
                                Angular component, view and the output for the code seperately</p>
                            <div class="d-flex flex-row justify-content-center mt-auto">
                                <a href="https://mifdhamilan.medium.com/bindings-in-angular-7d1b8e10b9c" target="_blank" target="_blank" type="button" class="btn btn-primary mr-3">Read More</a>     
                            </div>       
                    </div>
                </div>
            </div>
        </div>
    </div>
